import ConfirmSwitchCompanyContext from 'contexts/ConfirmSwitchCompanyContext';
import { useContext } from 'react';

const useConfirmSwitchCompany = () => {
  const { openDialog } = useContext(ConfirmSwitchCompanyContext);
  return { openDialog };
};

export default useConfirmSwitchCompany;
